export default "__VITE_ASSET__BLH1DaZj__"